<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <section id="ngx-datatable-shipping">
            <div class="card">
                <div class="card-title d-flex justify-content-between align-items-center">
                    <h4>Repartidores/Distribuidores</h4>
                    <button class="btn btn-primary" rippleEffect [routerLink]="['/pages/dealers-create']">
                        <i data-feather="plus" class="mr-0 mr-sm-1"></i><span class="d-none d-sm-inline-block">
                            Nuevo</span>
                    </button>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="d-flex justify-content-between align-items-center m-1">
                                <label class="d-flex align-items-center">Mostrando
                                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option *ngIf="dealers.length > 15" [value]="dealers.length">Todos</option>
                                    </select>
                                    repartidores</label>
                            </div>
                        </div>
                        <div class="col-md-6 col-12 d-flex justify-content-md-end">
                            <div class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0">
                                <label class="d-flex align-items-center mb-1">Buscar<input #searchInput type="search" placeholder="Repartidor"
                                        class="form-control ml-25" (keyup)="FilterUpdate(searchInput.value)"
                                        (search)="FilterUpdate(searchInput.value)" /></label>
                                <button class="btn btn-success align-items-center ml-1 mb-1" placement="left"
                                ngbTooltip="Exportar" type="button" (click)="exportexcel()"
                                    [disabled]="!dealers?.length">
                                    <em class="fa fa-print"></em>
                                </button>
                            </div>
                        
                        </div>
                    </div> 
                    <ngx-datatable [rows]="dealers" [rowHeight]="58" class="bootstrap core-bootstrap"
                        [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50" [scrollbarH]="true"
                        [limit]="basicSelectedOption"
                        [messages]="{emptyMessage: 'No hay información para mostrar', totalMessage: 'Total de repartidores'}">
                        <ngx-datatable-column name="Nombre" prop="userName"></ngx-datatable-column>
                        <ngx-datatable-column name="Usuario" prop="userUserName"></ngx-datatable-column>
                        <ngx-datatable-column name="Ubicación" prop="location">
                            <ng-template let-location="value" ngx-datatable-cell-template>
                            <div
                            placement="left"
                            [ngbTooltip]="'Ubicacion: ' + location"
                          >
                            <span
                              class="d-inline-block text-truncate"
                              style="max-width: 130px"
                              >{{ location | limitText }}</span
                            >
                          </div>
                        </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Dirección" prop="address">
                            <ng-template let-address="value" ngx-datatable-cell-template>
                                <span class="d-inline-block text-truncate"
                                        style="max-width: 150px;">{{address | limitText}}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Acciones" [width]="200" [sortable]="false" prop="id">
                            <ng-template ngx-datatable-cell-template let-dealerId="value">
                                <button class="btn btn-outline-light text-primary dropbtn" [ngbPopover]="popoverTemplate" #popOver="ngbPopover"
                                    data-container="body" placement="left-top" [autoClose]="'outside'" type="button" id="defaultDropdown"
                                    aria-expanded="false">
                                    <em class="fa fa-bars"></em>
                                </button>
                                <ng-template #popoverTemplate style="overflow: visible;">
                                    <div>
                                        <button type="button" ngbTooltip="Editar" placement="left"
                                            class="btn btn-icon btn-outline-info text-info cursor-pointer mr-50" rippleEffect
                                            [routerLink]="'/pages/dealers-create/' + dealerId">
                                            <span [data-feather]="'edit'"></span></button>
                                        <button type="button" ngbTooltip="Eliminar" placement="left"
                                            class="btn btn-icon btn-outline-danger text-danger cursor-pointer mr-50" rippleEffect
                                            (click)="DeleteDealer(dealerId)">
                                            <span [data-feather]="'trash-2'"></span></button>
                                        <button type="button" ngbTooltip="Comisión del repartidor" placement="left"
                                            class="btn btn-icon btn-outline-primary text-primary cursor-pointer mr-50" rippleEffect
                                            (click)="CurrencySetting(dealerId)">
                                            <span [data-feather]="'dollar-sign'"></span></button>
                                        <button type="button" ngbTooltip="Gestionar Municipios" placement="left"
                                            class="btn btn-icon btn-outline-primary text-primary cursor-pointer mr-50" rippleEffect
                                            (click)="CityAssigment(dealerId)">
                                            <span [data-feather]="'check-square'"></span></button>
                                    </div>
                                </ng-template>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </section>
    </div>
</div>